<template>
  <div>
    <p>确定匿名举报该{{ replyId ? "回复" : "话题" }}?</p>
    <el-form label-position="top">
      <el-form-item>
        <el-radio-group v-model="reason">
          <p><el-radio label="广告"></el-radio></p>
          <p><el-radio label="不当言语"></el-radio></p>
          <p><el-radio label="多次刷屏"></el-radio></p>
          <p><el-radio label="其他"></el-radio></p>
        </el-radio-group>
      </el-form-item>
      <el-button style="float: right" @click="reportSpam">匿名举报</el-button>
    </el-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      reason: "广告"
    };
  },
  props: {
    topicId: {
      required: true
    },
    replyId: {
      required: false
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    reportSpam: function() {
      var url = `/spam/` + this.topicId;
      if (this.replyId) {
        url += "/" + this.replyId;
      }
      url += "?reason=" + this.reason;
      this.setLoading(true);
      this.$http.get(url).then(res => {
        if (res.status == 202) {
          this.setLoading(false);
          this.$message({
            showClose: true,
            type: "success",
            message:
              "已成功匿名举报该" + (this.replyId ? "回复" : "话题") + "！"
          });
          this.$emit("close");
        }
      });
      this.setLoading(false);
    }
  }
};
</script>
